import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css']
})
export class EmployeeComponent implements OnInit {

  branchList = [];
  countryList = [];
  city = [];
  cityList = [];
  // employee_no;
  occupationList = []; 
  custodyAcctList = [];
  loanAcctList = [];
  custodyAcctDetail = '';
  loanAcctDetail = '';

  model = {
    'table_name': 'employee', 'employee_id': '0', 'employee_no': '', 'name': '', 'name_en': '', 'mobile': '',
    'branch_id': '0', 'city_id': '0', 'national_id': '', 'address': '', 'nationality': '0', 'is_rep': 0, 
    'bank_name': '', 'bank_acct_number': '', 'wp_no': '', 'wp_exp': '0000-00-00', 'occupation_id': '0', 
    'national_id_exp': '0000-00-00', 'passport_no': '',
    'passport_exp': '0000-00-00', 'join_date': '0000-00-00', 'has_custody': 0, 'custody_acct_number': '', 
    'has_loan': 0, 'loan_acct_number': '', 'key': 'employee_id', 'flag': 'new', 'comment': ''
  };

  date_model = {
    'join_date_d': new Date(), 'national_id_exp_d': new Date(), 'passport_exp_d': new Date(),
    'wp_exp_d': new Date(), 'custody_base_date': this.applicationConstants.business_cycle.start_date, 
    'loan_base_date': this.applicationConstants.business_cycle.start_date
  };
  country_model = { 'country_id': '', 'nationality': '' };
  emp_no_model = { 'emp_no': 0 };

  custody_acct_model = {
    'table_name': 'sub_acct', 'sub_acct_id': '0', 
    'acct_type_no': this.applicationConstants.acct_type_config['custody'], 
    'main_acct_no': this.applicationConstants.main_acct_config['custody'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct':'', 'acct_level': '0', 'is_leaf': '1', 
    'is_cc':'1', 'emp_no': '0', 'key': 'sub_acct_id', 'flag': 'new', 'deletable': '1'
  };

  custody_base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'base_date': '', 'acct_number': '', 
    'main_acct_no': this.applicationConstants.main_acct_config['custody'],
    'acct_type_no': this.applicationConstants.acct_type_config['custody'], 'key': 'baseline_id', 
    'flag': 'new', 'baseline_amount': '0'
  };

  loan_acct_model = {
    'table_name': 'sub_acct', 'sub_acct_id': '0', 
    'acct_type_no': this.applicationConstants.acct_type_config['loan'], 
    'main_acct_no': this.applicationConstants.main_acct_config['loan'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct':'', 'acct_level': '0', 'is_leaf': '1', 
    'is_cc':'1', 'emp_no': '0', 'key': 'sub_acct_id', 'flag': 'new', 'deletable': '1'
  };
  loan_base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'base_date': '', 'acct_number': '', 
    'main_acct_no': this.applicationConstants.main_acct_config['loan'],
    'acct_type_no': this.applicationConstants.acct_type_config['loan'], 'key': 'baseline_id', 
    'flag': 'new', 'baseline_amount': '0'
  };

  Success_Msg; Error_Msg; Emp_Name_Msg; Eng_Name_Msg;
  Cont_City_Msg; Mobile_Msg; Branch_Msg; Emp_No_Exist;
  Cust_Acct_No_Exist; Loan_Acct_No_Exist; Nationality_Msg;
  Occupation_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<EmployeeComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Emp_Name_Msg').subscribe((res: string) => {
      this.Emp_Name_Msg = res;
    });

    translate.get('Eng_Name_Msg').subscribe((res: string) => {
      this.Eng_Name_Msg = res;
    });

    translate.get('Cont_City_Msg').subscribe((res: string) => {
      this.Cont_City_Msg = res;
    });

    translate.get('Mobile_Msg').subscribe((res: string) => {
      this.Mobile_Msg = res;
    });

    translate.get('Branch_Msg').subscribe((res: string) => {
      this.Branch_Msg = res;
    });
    
    translate.get('Emp_No_Exist').subscribe((res: string) => {
      this.Emp_No_Exist = res;
    });
    
    translate.get('Cust_Acct_No_Exist').subscribe((res: string) => {
      this.Cust_Acct_No_Exist = res;
    });

    translate.get('Loan_Acct_No_Exist').subscribe((res: string) => {
      this.Loan_Acct_No_Exist = res;
    });
    
    translate.get('Nationality_Msg').subscribe((res: string) => {
      this.Nationality_Msg = res;
    });
    
    translate.get('Occupation_Msg').subscribe((res: string) => {
      this.Occupation_Msg = res;
    });
  }

  ngOnInit() {
    let query, obj;

    // get not leaf custody accts
    let custody_parent_acct = this.applicationConstants.main_acct_config['custody'];
    obj = { cmd: 'getAccountList', parent_acct: custody_parent_acct, include_parent: true, add_leaf: false };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.custodyAcctList = data.data['list'];

        if (this.dialog_data == null || (this.dialog_data != null && this.dialog_data[0]['custody_acct_number'] == '')) {
          if (this.custodyAcctList.length > 0) {
            custody_parent_acct = this.custodyAcctList[0]['acct_number'];
            this.custodyAcctDetail = custody_parent_acct + ' - ' + this.custodyAcctList[0]['sub_acct_name'] + ' - ' + 
              this.custodyAcctList[0]['sub_acct_name_en'];
          }
          else 
            this.custodyAcctDetail = custody_parent_acct + ' - حسابات العهد - Custody Accounts';

          this.onChangeCustAcctSearch("", custody_parent_acct);
        }
      });

    // get not leaf loan accts
    let loan_parent_acct = this.applicationConstants.main_acct_config['loan'];
    obj = { cmd: 'getAccountList', parent_acct: loan_parent_acct, include_parent: true, add_leaf: false };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.loanAcctList = data.data['list'];

        if (this.dialog_data == null || (this.dialog_data != null && this.dialog_data[0]['loan_acct_number'] == '')) {
          if (this.loanAcctList.length > 0) {
            loan_parent_acct = this.loanAcctList[0]['acct_number'];
            this.loanAcctDetail = loan_parent_acct + ' - ' + this.loanAcctList[0]['sub_acct_name'] + ' - ' + 
              this.loanAcctList[0]['sub_acct_name_en'];
          }
          else 
            this.loanAcctDetail = loan_parent_acct + ' - حسابات السلف - Loan Accounts';

          this.onChangeLoanAcctSearch("", loan_parent_acct);
        }
      });

    if (this.dialog_data != null) {
      this.model = this.dialog_data[0];
      this.country_model = this.dialog_data[1];

      this.date_model['join_date_d'] = this.dialog_data[2]['join_date_d'];
      this.date_model['national_id_exp_d'] = this.dialog_data[2]['national_id_exp_d'];
      this.date_model['passport_exp_d'] = this.dialog_data[2]['passport_exp_d'];
      this.date_model['wp_exp_d'] = this.dialog_data[2]['wp_exp_d'];
      // this.employee_no = this.model.employee_no;
      if (this.model['comment'] == null)
        this.model['comment'] = '';

      if (this.model['custody_acct_number'] != '') {
        // retreive custody acct detail
        query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['custody_acct_number'] + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let custodyAcct = data.data['list'][0];
            // fill custody model
            this.custody_acct_model['sub_acct_id'] = custodyAcct['sub_acct_id'];
            this.custody_acct_model['sub_acct_name'] = custodyAcct['sub_acct_name'];
            this.custody_acct_model['sub_acct_name_en'] = custodyAcct['sub_acct_name_en'];
            this.custody_acct_model['acct_number'] = custodyAcct['acct_number'];
            this.custody_acct_model['parent_acct'] = custodyAcct['parent_acct'];
            this.custody_acct_model['acct_level'] = custodyAcct['acct_level'];
            this.custody_acct_model['is_leaf'] = custodyAcct['is_leaf'];
            this.custody_acct_model['is_cc'] = custodyAcct['is_cc'];
            this.custody_acct_model['emp_no'] = custodyAcct['emp_no'];
            this.custody_acct_model['flag'] = 'update';
            this.custody_acct_model['deletable'] = custodyAcct['deletable'];

            // retreive parent detail 
            query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + custodyAcct['parent_acct'] + "'";
            obj = { cmd: 'getList', query: query };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let custodyParentAcct = data.data['list'][0];
                this.custodyAcctDetail = custodyAcct['parent_acct'] + " - " + custodyParentAcct['sub_acct_name'] + 
                  " - " + custodyParentAcct['sub_acct_name_en'];
              });
          });
      }

      if (this.model['loan_acct_number'] != '') {
        // retreive loan acct detail
        query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['loan_acct_number'] + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let loanAcct = data.data['list'][0];
            // fill custody model
            this.loan_acct_model['sub_acct_id'] = loanAcct['sub_acct_id'];
            this.loan_acct_model['sub_acct_name'] = loanAcct['sub_acct_name'];
            this.loan_acct_model['sub_acct_name_en'] = loanAcct['sub_acct_name_en'];
            this.loan_acct_model['acct_number'] = loanAcct['acct_number'];
            this.loan_acct_model['parent_acct'] = loanAcct['parent_acct'];
            this.loan_acct_model['acct_level'] = loanAcct['acct_level'];
            this.loan_acct_model['is_leaf'] = loanAcct['is_leaf'];
            this.loan_acct_model['is_cc'] = loanAcct['is_cc'];
            this.loan_acct_model['emp_no'] = loanAcct['emp_no'];
            this.loan_acct_model['flag'] = 'update';
            this.loan_acct_model['deletable'] = loanAcct['deletable'];
 
            // retreive parent detail 
            query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + loanAcct['parent_acct'] + "'";
            obj = { cmd: 'getList', query: query };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let loanParentAcct = data.data['list'][0];
                this.loanAcctDetail = loanAcct['parent_acct'] + " - " + loanParentAcct['sub_acct_name'] + 
                  " - " + loanParentAcct['sub_acct_name_en'];
              });
          });
      }
    }

    query = this.queryList.all_branch;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
      });

    query = this.queryList.all_occupation;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.occupationList = data.data['list'];
      });

    query = this.queryList.all_country;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.countryList = data.data['list'];
      });

    query = this.queryList.all_city;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
        if (this.dialog_data != null)
          this.getCity();
      });
  }

  getCity() {
    this.cityList = [];
    this.city.forEach(element => {
      if (element.country_id == this.country_model['country_id'])
        this.cityList.push(element);
    });
  }

  empNO() {
    let employee_no = document.getElementById('employee_no') as HTMLInputElement;
    let emp_no = document.getElementById('emp_no') as HTMLInputElement;

    this.model['employee_no'] = '';
    // employee_no.value = '';
    employee_no.disabled = (emp_no.checked);
  }

  onChangeCustAcctSearch = function (acct_number: string, parent_acct: string) {
    console.log(acct_number);

    if (acct_number != '' || parent_acct != '') {
      this.custody_acct_model['parent_acct'] = "";
      this.custody_acct_model['acct_level'] = "0";

      if (acct_number != '')
        this.custody_acct_model['parent_acct'] = acct_number;
      else if (parent_acct != '') 
        this.custody_acct_model['parent_acct'] = parent_acct;

      // if (this.custody_acct_model['parent_acct'] != "") {
      var element;
      for (let index = 0; index < this.custodyAcctList.length; index++) {
        element = this.custodyAcctList[index];
        if (element.acct_number == this.custody_acct_model['parent_acct']) {
          this.custody_acct_model['acct_level'] = String(Number(element.acct_level) + 1);
          break;
        }
      }
      if (this.custody_acct_model['acct_level'] == "0") 
        this.custody_acct_model['acct_level'] = String(Number(this.custody_acct_model['acct_level']) + 1);

      if (this.model['employee_id'] == '0' || (this.model['employee_id'] != '0' && this.model['custody_acct_number'] == '')) {
        this.custody_acct_model['acct_number'] = "";
        
        let query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" + 
          this.custody_acct_model['parent_acct'] + "'";
        let obj = { cmd: 'getList', query: query };
        
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            
            let result = Number(data.data['list'][0]['acct_number']);
            if (result == 0) 
              this.custody_acct_model['acct_number'] = this.custody_acct_model['parent_acct'] + "001";
            else
              this.custody_acct_model['acct_number'] = String(result + 1);
          });
        // }
      }
      
    }
  }

  changeCustAcctNumber() {
    if (this.custody_acct_model['acct_number'] == "" && this.custody_acct_model['parent_acct'] != "")
      this.onChangeCustAcctSearch("", this.custody_acct_model['parent_acct']);
  }

  onChangeLoanAcctSearch = function (acct_number: string, parent_acct: string) {
    console.log(acct_number);

    if (acct_number != '' || parent_acct != '') {
      this.loan_acct_model['parent_acct'] = "";
      this.loan_acct_model['acct_level'] = "0";

      if (acct_number != '')
        this.loan_acct_model['parent_acct'] = acct_number;
      else if (parent_acct != '') 
        this.loan_acct_model['parent_acct'] = parent_acct;

      // if (this.loan_acct_model['parent_acct'] != "") {
      var element;
      for (let index = 0; index < this.loanAcctList.length; index++) {
        element = this.loanAcctList[index];
        if (element.acct_number == this.loan_acct_model['parent_acct']) {
          this.loan_acct_model['acct_level'] = String(Number(element.acct_level) + 1);
          break;
        }
      }
      if (this.loan_acct_model['acct_level'] == "0") 
        this.loan_acct_model['acct_level'] = String(Number(this.loan_acct_model['acct_level']) + 1);

      if (this.model['employee_id'] == '0' || (this.model['employee_id'] != '0' && this.model['loan_acct_number'] == '')) {
        this.loan_acct_model['acct_number'] = "";
        
        let query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" + 
          this.loan_acct_model['parent_acct'] + "'";
        let obj = { cmd: 'getList', query: query };
        
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            
            let result = Number(data.data['list'][0]['acct_number']);
            if (result == 0) 
              this.loan_acct_model['acct_number'] = this.loan_acct_model['parent_acct'] + "001";
            else
              this.loan_acct_model['acct_number'] = String(result + 1);
          });
        // }
      }
      
    }
  }

  changeLoanAcctNumber() {
    if (this.loan_acct_model['acct_number'] == "" && this.loan_acct_model['parent_acct'] != "")
      this.onChangeLoanAcctSearch("", this.loan_acct_model['parent_acct']);
  }

  add() {
    if (this.model['name'] == '') {
      alert(this.Emp_Name_Msg);
      (document.getElementById('name') as HTMLInputElement).focus();
      return;
    }
    
    if (this.model['name_en'] == '') {
      alert(this.Eng_Name_Msg);
      (document.getElementById('name_en') as HTMLInputElement).focus();
      return;
    }

    if (this.model['mobile'] == '') {
      alert(this.Mobile_Msg);
      (document.getElementById('mobile') as HTMLInputElement).focus();
      return;
    }
    
    if (this.model['city_id'] == '0') {
      alert(this.Cont_City_Msg);
      (document.getElementById('city_id') as HTMLInputElement).focus();
      return;
    }

    if (this.model['branch_id'] == '0') {
      alert(this.Branch_Msg);
      (document.getElementById('branch_id') as HTMLInputElement).focus();
      return;
    }

    if (this.model['nationality'] == '0') {
      alert(this.Nationality_Msg);
      (document.getElementById('nationality') as HTMLInputElement).focus();
      return;
    }

    if (this.model['occupation_id'] == '0') {
      alert(this.Occupation_Msg);
      (document.getElementById('occupation_id') as HTMLInputElement).focus();
      return;
    }
    
    if (this.emp_no_model['emp_no']) this.emp_no_model['emp_no'] = 1; else this.emp_no_model['emp_no'] = 0;
    if (this.model['has_custody']) this.model['has_custody'] = 1; else this.model['has_custody'] = 0;
    if (this.model['has_loan']) this.model['has_loan'] = 1; else this.model['has_loan'] = 0;
    if (this.model['is_rep']) this.model['is_rep'] = 1; else this.model['is_rep'] = 0;

    this.model['join_date'] = (this.date_model['join_date_d'].getFullYear() + "-" +
      (this.date_model['join_date_d'].getMonth() + 1) + "-" + this.date_model['join_date_d'].getDate());

    this.model['national_id_exp'] = (this.date_model['national_id_exp_d'].getFullYear() + "-" +
      (this.date_model['national_id_exp_d'].getMonth() + 1) + "-" + this.date_model['national_id_exp_d'].getDate());
    
    this.model['passport_exp'] = (this.date_model['passport_exp_d'].getFullYear() + "-" +
      (this.date_model['passport_exp_d'].getMonth() + 1) + "-" + this.date_model['passport_exp_d'].getDate());

    this.model['wp_exp'] = (this.date_model['wp_exp_d'].getFullYear() + "-" +
      (this.date_model['wp_exp_d'].getMonth() + 1) + "-" + this.date_model['wp_exp_d'].getDate());

    // this.model['nationality'] = this.country_model['nationality'];
    let values = [];
    let query, obj;

    if (this.model['employee_id'] == '0') {

      if (this.emp_no_model['emp_no'] == 0) {

        query = "SELECT `employee_id` FROM `employee` WHERE `employee_no` = '" + 
          this.model['employee_no'] + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.data['list'].length > 0)
            alert(this.Emp_No_Exist);
          else {
            values.push(this.model);

            if (this.model['has_custody'] == 1) {

              // check custody account number
              query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
                this.custody_acct_model['acct_number'] + "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  
                  let result = data.data['list'];
                  if (result.length > 0) 
                    alert(this.Cust_Acct_No_Exist);  
                  else {
                    this.model['custody_acct_number'] = this.custody_acct_model['acct_number'];
                    this.custody_acct_model['emp_no'] = this.model['employee_no'];
                    this.custody_acct_model['sub_acct_name'] = ' عهدة ' + this.model['name'];
                    this.custody_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Custody';
                    values.push(this.custody_acct_model);

                    this.custody_base_model['base_date'] = (this.date_model['custody_base_date'].getFullYear() + '-' +
                      (this.date_model['custody_base_date'].getMonth() + 1) + '-' + this.date_model['custody_base_date'].getDate());
                    this.custody_base_model['acct_number'] = this.custody_acct_model['acct_number'];
                    values.push(this.custody_base_model);

                    if (this.model['has_loan'] == 1) {
              
                      // check loan account number
                      query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
                        this.loan_acct_model['acct_number'] + "'";
                      obj = { cmd: 'getList', query: query };

                      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                        .subscribe(data => {
                          this.applicationConstants.appComp.hideBusyCursor();
                          
                          let result = data.data['list'];
                          if (result.length > 0) 
                            alert(this.Loan_Acct_No_Exist);  
                          else {
                            this.model['loan_acct_number'] = this.loan_acct_model['acct_number'];
                            this.loan_acct_model['emp_no'] = this.model['employee_no'];
                            this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
                            this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
                            values.push(this.loan_acct_model);
              
                            this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
                              (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
                            this.loan_base_model['acct_number'] = this.loan_acct_model['acct_number'];
                            values.push(this.loan_base_model);

                            obj = { cmd: 'add', values: values };
                            this.saveEmployee(obj, []);
                          }
                        });
                    }
                    else {
                      obj = { cmd: 'add', values: values };
                      this.saveEmployee(obj, []);
                    }
                  }
                });
            }
            else if (this.model['has_loan'] == 1) {

              // check loan account number
              query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
                this.loan_acct_model['acct_number'] + "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  
                  let result = data.data['list'];
                  if (result.length > 0) 
                    alert(this.Loan_Acct_No_Exist);  
                  else {
                    this.model['loan_acct_number'] = this.loan_acct_model['acct_number'];
                    this.loan_acct_model['emp_no'] = this.model['employee_no'];
                    this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
                    this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
                    values.push(this.loan_acct_model);

                    this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
                      (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
                    this.loan_base_model['acct_number'] = this.loan_acct_model['acct_number'];
                    values.push(this.loan_base_model);

                    obj = { cmd: 'add', values: values };
                    this.saveEmployee(obj, []);
                  }
                });
            }
            else {
              obj = { cmd: 'add', values: values };
              this.saveEmployee(obj, []);
            }
          }
        });
      }
      else {
        values.push(this.model);
        let values2 = [];
        
        if (this.model['has_custody'] == 1) {

          // check custody account number
          query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
            this.custody_acct_model['acct_number'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              
              let result = data.data['list'];
              if (result.length > 0) 
                alert(this.Cust_Acct_No_Exist);  
              else {
                this.model['custody_acct_number'] = this.custody_acct_model['acct_number'];
                this.custody_acct_model['emp_no'] = this.model['employee_no'];
                this.custody_acct_model['sub_acct_name'] = ' عهدة ' + this.model['name'];
                this.custody_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Custody';
                values2.push(this.custody_acct_model);

                this.custody_base_model['base_date'] = (this.date_model['custody_base_date'].getFullYear() + '-' +
                  (this.date_model['custody_base_date'].getMonth() + 1) + '-' + this.date_model['custody_base_date'].getDate());
                this.custody_base_model['acct_number'] = this.custody_acct_model['acct_number'];
                values2.push(this.custody_base_model);

                if (this.model['has_loan'] == 1) {
          
                  // check loan account number
                  query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
                    this.loan_acct_model['acct_number'] + "'";
                  obj = { cmd: 'getList', query: query };

                  this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                    .subscribe(data => {
                      this.applicationConstants.appComp.hideBusyCursor();
                      
                      let result = data.data['list'];
                      if (result.length > 0) 
                        alert(this.Loan_Acct_No_Exist);  
                      else {
                        this.model['loan_acct_number'] = this.loan_acct_model['acct_number'];
                        this.loan_acct_model['emp_no'] = this.model['employee_no'];
                        this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
                        this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
                        values2.push(this.loan_acct_model);
          
                        this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
                          (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
                        this.loan_base_model['acct_number'] = this.loan_acct_model['acct_number'];
                        values2.push(this.loan_base_model);

                        obj = {
                          cmd: 'add', values: values, pk: 'employee_no', id: 'employee_id', main_table: 'employee',
                          prefix: '400'
                        };
                        this.saveEmployee(obj, values2);
                      }
                    });
                }
                else {
                  obj = {
                    cmd: 'add', values: values, pk: 'employee_no', id: 'employee_id', main_table: 'employee',
                    prefix: '400'
                  };
                  this.saveEmployee(obj, values2);
                }
              }
            });
        }
        else if (this.model['has_loan'] == 1) {

          // check loan account number
          query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
            this.loan_acct_model['acct_number'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              
              let result = data.data['list'];
              if (result.length > 0) 
                alert(this.Loan_Acct_No_Exist);  
              else {
                this.model['loan_acct_number'] = this.loan_acct_model['acct_number'];
                this.loan_acct_model['emp_no'] = this.model['employee_no'];
                this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
                this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
                values2.push(this.loan_acct_model);

                this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
                  (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
                this.loan_base_model['acct_number'] = this.loan_acct_model['acct_number'];
                values2.push(this.loan_base_model);

                obj = {
                  cmd: 'add', values: values, pk: 'employee_no', id: 'employee_id', main_table: 'employee',
                  prefix: '400'
                };
                this.saveEmployee(obj, values2);
              }
            });
        }
        else {
          obj = {
            cmd: 'add', values: values, pk: 'employee_no', id: 'employee_id', main_table: 'employee',
            prefix: '400'
          };
          this.saveEmployee(obj, []);
        }
      }
    }
    else {
      values.push(this.model);

      if (this.model['has_custody'] == 1) {

        if (this.model['custody_acct_number'] == '') {

          // check custody account number
          query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
            this.custody_acct_model['acct_number'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              
              let result = data.data['list'];
              if (result.length > 0) 
                alert(this.Cust_Acct_No_Exist);  
              else {
                this.model['custody_acct_number'] = this.custody_acct_model['acct_number'];
                this.custody_acct_model['emp_no'] = this.model['employee_no'];
                this.custody_acct_model['sub_acct_name'] = ' عهدة ' + this.model['name'];
                this.custody_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Custody';
                values.push(this.custody_acct_model);

                this.custody_base_model['base_date'] = (this.date_model['custody_base_date'].getFullYear() + '-' +
                  (this.date_model['custody_base_date'].getMonth() + 1) + '-' + this.date_model['custody_base_date'].getDate());
                this.custody_base_model['acct_number'] = this.custody_acct_model['acct_number'];
                values.push(this.custody_base_model);

                if (this.model['has_loan'] == 1) {
          
                  if (this.model['loan_acct_number'] == '') {

                    // check loan account number
                    query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
                      this.loan_acct_model['acct_number'] + "'";
                    obj = { cmd: 'getList', query: query };

                    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                      .subscribe(data => {
                        this.applicationConstants.appComp.hideBusyCursor();
                        
                        let result = data.data['list'];
                        if (result.length > 0) 
                          alert(this.Loan_Acct_No_Exist);  
                        else {
                          this.model['loan_acct_number'] = this.loan_acct_model['acct_number'];
                          this.loan_acct_model['emp_no'] = this.model['employee_no'];
                          this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
                          this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
                          values.push(this.loan_acct_model);
            
                          this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
                            (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
                          this.loan_base_model['acct_number'] = this.loan_acct_model['acct_number'];
                          values.push(this.loan_base_model);

                          obj = { cmd: 'updateAdv', values: values };
                          this.saveEmployee(obj, []);
                        }
                      });
                  }
                  else {
                    this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
                    this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
                    values.push(this.loan_acct_model);

                    obj = { cmd: 'updateAdv', values: values };
                    this.saveEmployee(obj, []);
                  }
                }
                else {
                  obj = { cmd: 'updateAdv', values: values };
                  this.saveEmployee(obj, []);
                }
              }
            });
        }
        else {
          this.custody_acct_model['sub_acct_name'] = ' عهدة ' + this.model['name'];
          this.custody_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Custody';
          values.push(this.custody_acct_model);

          if (this.model['has_loan'] == 1) {
            if (this.model['loan_acct_number'] == '') {

              // check loan account number
              query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
                this.loan_acct_model['acct_number'] + "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  
                  let result = data.data['list'];
                  if (result.length > 0) 
                    alert(this.Loan_Acct_No_Exist);  
                  else {
                    this.model['loan_acct_number'] = this.loan_acct_model['acct_number'];
                    this.loan_acct_model['emp_no'] = this.model['employee_no'];
                    this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
                    this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
                    values.push(this.loan_acct_model);
      
                    this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
                      (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
                    this.loan_base_model['acct_number'] = this.loan_acct_model['acct_number'];
                    values.push(this.loan_base_model);

                    obj = { cmd: 'updateAdv', values: values };
                    this.saveEmployee(obj, []);
                  }
                });
            }
            else {
              this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
              this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
              values.push(this.loan_acct_model);

              obj = { cmd: 'updateAdv', values: values };
              this.saveEmployee(obj, []);
            }
          }
          else {
            obj = { cmd: 'updateAdv', values: values };
            this.saveEmployee(obj, []);
          }
        }
      }
      else if (this.model['has_loan'] == 1) {
        
        if (this.model['loan_acct_number'] == '') {

          // check loan account number
          query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + 
            this.loan_acct_model['acct_number'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              
              let result = data.data['list'];
              if (result.length > 0) 
                alert(this.Loan_Acct_No_Exist);  
              else {
                this.model['loan_acct_number'] = this.loan_acct_model['acct_number'];
                this.loan_acct_model['emp_no'] = this.model['employee_no'];
                this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
                this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
                values.push(this.loan_acct_model);
  
                this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
                  (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
                this.loan_base_model['acct_number'] = this.loan_acct_model['acct_number'];
                values.push(this.loan_base_model);

                obj = { cmd: 'updateAdv', values: values };
                this.saveEmployee(obj, []);
              }
            });
        }
        else {
          this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
          this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
          values.push(this.loan_acct_model);

          obj = { cmd: 'updateAdv', values: values };
          this.saveEmployee(obj, []);
        }
      }
      else {
        obj = { cmd: 'updateAdv', values: values };
        this.saveEmployee(obj, []);
      }
    }

    // if (this.emp_no_model['emp_no'] == 0) {
    //   // let flag = true;
    //   // let empNo = [];
    //   let query = "SELECT `employee_id` FROM `employee` WHERE `employee_no` = '" + this.model['employee_no'] + 
    //     "'";
    //   let obj1 = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();
    //       if (data.data['list'].length > 0 && this.model['employee_id'] == '0')
    //         alert("رقم الموظف موجود سابقًا");
    //       else {
    //         let values = [];
    //         values.push(this.model);

    //         let obj;
    //         // let prefix;
    //         if (this.model['employee_id'] == '0') {

    //           if (this.model['has_custody'] == 1) {

    //             // check custody account number

    //             this.custody_acct_model['emp_no'] = this.model['employee_no'];
    //             this.custody_acct_model['sub_acct_name'] = ' عهدة ' + this.model['name'];
    //             this.custody_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Custody';
    //             values.push(this.custody_acct_model);

    //             this.custody_base_model['base_date'] = (this.date_model['custody_base_date'].getFullYear() + '-' +
    //               (this.date_model['custody_base_date'].getMonth() + 1) + '-' + this.date_model['custody_base_date'].getDate());
    //             values.push(this.custody_base_model);

    //             // prefix = '104';
    //             // obj = {
    //             //   cmd: 'add', values: values, pk: 'acct_number', id: 'sub_acct_id', main_table: 'sub_acct',
    //             //   prefix: prefix
    //             // };
    //           }
             
    //           if (this.model['has_loan'] == 1) {

    //             // check loan account number
    //             this.loan_acct_model['emp_no'] = this.model['employee_no'];
    //             this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
    //             this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
    //             values.push(this.loan_acct_model);

    //             this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
    //               (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
    //             values.push(this.loan_base_model);

    //             // prefix = '106';
    //             // obj = {
    //             //   cmd: 'add', values: values, pk: 'acct_number', id: 'sub_acct_id', main_table: 'sub_acct',
    //             //   prefix: prefix
    //             // };
    //           }
    //           obj = { cmd: 'add', values: values };
    //         }
    //         else if (this.model['employee_id'] != '0') {
    //           let where = [{ 'employee_id': this.model['employee_id'] }];
    //           let values1 = [];
    //           values1.push(this.model);
    //           obj = { cmd: 'update', values: values1, where: where };
    //         }

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();
    //             if (data.status['type'] == 'success') {
    //               if (obj.cmd == 'add') {
    //                 if (this.model['has_custody'] == 1 && this.model['has_loan'] == 1) {
    //                   values = [];
    //                   this.loan_acct_model['emp_no'] = this.model['employee_no'];
    //                   this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
    //                   this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
    //                   values.push(this.loan_acct_model);

    //                   this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
    //                     (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
    //                   values.push(this.loan_base_model);

    //                   // prefix = '106';
    //                   // obj = {
    //                   //   cmd: 'add', values: values, pk: 'acct_number', id: 'sub_acct_id', main_table: 'sub_acct',
    //                   //   prefix: prefix
    //                   // };

    //                   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                     .subscribe(data => {
    //                       this.applicationConstants.appComp.hideBusyCursor();
    //                       if (data.status['type'] == 'success') {
    //                         alert(this.Success_Msg);
    //                         this.dialog_data = { 'op_type': 'success' };
    //                         this.dialogRef.close(this.dialog_data);
    //                       }
    //                       else
    //                         alert(this.Error_Msg);
    //                     });
    //                 }
    //                 else {
    //                   alert(this.Success_Msg);
    //                   this.dialog_data = { 'op_type': 'success' };
    //                   this.dialogRef.close(this.dialog_data);
    //                 }
    //               }
    //               else {
    //                 alert(this.Success_Msg);
    //                 this.dialog_data = { 'op_type': 'success' };
    //                 this.dialogRef.close(this.dialog_data);
    //               }
    //             }
    //             else {
    //               alert(this.Error_Msg);
    //             }
    //           });
    //       }
    //     });
    // }

    // else if (this.emp_no_model['emp_no'] == 1) {
    //   let values = [];
    //   values.push(this.model);
    //   let prefix;
    //   let obj;
    //   if (this.model['employee_id'] == '0') {
    //     // this.model['employee_no'] = '400';
    //     prefix = '400';
    //     obj = {
    //       cmd: 'add', values: values, pk: 'employee_no', id: 'employee_id', main_table: 'employee',
    //       prefix: prefix
    //     };
    //   }
    //   else {
    //     let where = [{ 'employee_id': this.model['employee_id'] }];
    //     let values1 = [];
    //     this.model.employee_no = this.employee_no;
    //     values1.push(this.model);
    //     obj = { cmd: 'update', values: values1, where: where };
    //   }

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();
    //       if (data.status['type'] == 'success') {
    //         if (obj.cmd == 'add') {
    //           let employee_no = '400' + data.status['msg'][0]['number'];
    //           values = [];

    //           if (this.model['has_custody'] == 1 || this.model['has_loan'] == 1) {
    //             if (this.model['has_custody'] == 1) {
    //               this.custody_acct_model['emp_no'] = employee_no;
    //               this.custody_acct_model['sub_acct_name'] = ' عهدة ' + this.model['name'];
    //               this.custody_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Custody';
    //               values.push(this.custody_acct_model);

    //               this.custody_base_model['base_date'] = (this.date_model['custody_base_date'].getFullYear() + '-' +
    //                 (this.date_model['custody_base_date'].getMonth() + 1) + '-' + this.date_model['custody_base_date'].getDate());
    //               values.push(this.custody_base_model);

    //               prefix = '104';
    //               obj = {
    //                 cmd: 'add', values: values, pk: 'acct_number', id: 'sub_acct_id', main_table: 'sub_acct',
    //                 prefix: prefix
    //               };
    //             }
    //             else if (this.model['has_loan'] == 1) {
    //               this.loan_acct_model['emp_no'] = employee_no;
    //               this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
    //               this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
    //               values.push(this.loan_acct_model);

    //               this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
    //                 (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
    //               values.push(this.loan_base_model);

    //               prefix = '106';
    //               obj = {
    //                 cmd: 'add', values: values, pk: 'acct_number', id: 'sub_acct_id', main_table: 'sub_acct',
    //                 prefix: prefix
    //               };
    //             }

    //             this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //               .subscribe(data => {
    //                 this.applicationConstants.appComp.hideBusyCursor();
    //                 if (data.status['type'] == 'success') {
    //                   if (this.model['has_custody'] == 1 && this.model['has_loan'] == 1) {
    //                     values = [];
    //                     this.loan_acct_model['emp_no'] = employee_no;
    //                     this.loan_acct_model['sub_acct_name'] = ' سلفة ' + this.model['name'];
    //                     this.loan_acct_model['sub_acct_name_en'] = this.model['name_en'] + ' Loan';
    //                     values.push(this.loan_acct_model);

    //                     this.loan_base_model['base_date'] = (this.date_model['loan_base_date'].getFullYear() + '-' +
    //                       (this.date_model['loan_base_date'].getMonth() + 1) + '-' + this.date_model['loan_base_date'].getDate());
    //                     values.push(this.loan_base_model);

    //                     prefix = '106';
    //                     obj = {
    //                       cmd: 'add', values: values, pk: 'acct_number', id: 'sub_acct_id', main_table: 'sub_acct',
    //                       prefix: prefix
    //                     };

    //                     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                       .subscribe(data => {
    //                         this.applicationConstants.appComp.hideBusyCursor();
    //                         if (data.status['type'] == 'success') {
    //                           alert(this.Success_Msg);
    //                           this.dialog_data = { 'op_type': 'success' };
    //                           this.dialogRef.close(this.dialog_data);
    //                         }
    //                         else
    //                           alert(this.Error_Msg);
    //                       });
    //                   }
    //                   else {
    //                     alert(this.Success_Msg);
    //                     this.dialog_data = { 'op_type': 'success' };
    //                     this.dialogRef.close(this.dialog_data);
    //                   }
    //                 }
    //                 else {
    //                   alert(this.Error_Msg);
    //                 }
    //               });
    //           }
    //           else {
    //             alert(this.Success_Msg);
    //             this.dialog_data = { 'op_type': 'success' };
    //             this.dialogRef.close(this.dialog_data);
    //           }
    //         }
    //         else {
    //           alert(this.Success_Msg);
    //           this.dialog_data = { 'op_type': 'success' };
    //           this.dialogRef.close(this.dialog_data);
    //         }
    //       }
    //       else {
    //         alert(this.Error_Msg);
    //       }
    //     });

    // }
  }

  saveEmployee(obj: any, values: any) {
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          if (this.model['employee_id'] == '0' && this.model['employee_no'] == '') {
            this.model['employee_no'] = data.status['msg'][0]['number'];

            if (values.length > 0) {
              values[0]['emp_no'] = this.model['employee_no'];
              if (values.length > 2)
                values[2]['emp_no'] = this.model['employee_no'];

              obj = { cmd: 'add', values: values };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  if (data.status['type'] == 'success') {
                    alert(this.Success_Msg);
                    this.dialog_data = { 'op_type': 'success' };
                    this.dialogRef.close(this.dialog_data);
                  }
                  else 
                    alert(this.Error_Msg);
                });
            }
            else {
              alert(this.Success_Msg);
              this.dialog_data = { 'op_type': 'success' };
              this.dialogRef.close(this.dialog_data);
            }
          }
          else {
            alert(this.Success_Msg);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
        }
        else 
          alert(this.Error_Msg);
      });
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }
}
